import { BaseApi } from '@/core/api/base.api';
import { Room } from "@/core/api/room.api";
import { roomExamService } from "@/core/service/room.exam.service";
import { RoomInfo } from '@/core/api/room.info.api'

class ExamApi extends BaseApi {
  constructor() {
    super();
    Room.Exam = this;

    Room.ready(async e => {
      if(!RoomInfo.useModule('exam')){
        return;
      }

      this._eventListen(this.#Events);

      const isExamRoomMode = Room.getRoomData().room.roomMode === 'exam';
      if (!isExamRoomMode) {
        return;
      }

      const examInfo = await this.getExamInfo();
      let userAnswerList = null;
      if (Room.User.hasEmceeRole()) {
        userAnswerList = await this.getAllUserAnswers(examInfo)
      } else {
        const userSubmitStatus = await this.getUserSubmitStatus({ ...examInfo, userId: Room.getRoomData().me.userId });
        userSubmitStatus
          ? userAnswerList = await this.getUserAnswers({ ...examInfo, userId: Room.getRoomData().me.userId })
          : await this.createUserExam({ ...examInfo, username: Room.getRoomData().me.username });
      }

      if (userAnswerList) {
          Room.emit('room_exam_user_answers', userAnswerList);
      }

      const examDetail = await this.getExamDetail(examInfo);
      Room.emit('room_exam_ready', examDetail);
    });
  }

  #Events = {
    room_exam_start: function(e) {
      if (Room.User.isParticipantRole()) {
        this.createUserExam({
          roomExamId: e.data.roomExam.roomExamId,
          username: Room.User.getMe().nickname,
        });
      }

      Room.emit(e)
    },
    room_exam_end: function(e) {
      Room.emit(e)
    },
    room_exam_user_create: function(e) {
      Room.emit(e)
    },
    room_exam_user_submit: function(e) {
      Room.emit(e)
    },
    room_exam_user_complete: function(e) {
      Room.emit(e)
    }
  }

  async getExamInfo() {
    return (await roomExamService.getExamInfo()).data;
  }
  async getExamDetail(params) {
    return (await roomExamService.getExamDetail(params)).data;
  }
  async startExam(params) {
    return (await roomExamService.startExam(params)).data;
  }
  async endExam(params) {
    return (await roomExamService.endExam(params)).data;
  }
  async createUserExam(params) {
    return (await roomExamService.createUserExam(params)).data;
  }
  async getUserSubmitStatus(params) {
    return (await roomExamService.getUserSubmitStatus(params)).data;
  }
  async submitUserAnswers(params) {
    return (await roomExamService.submitUserAnswers(params)).data;
  }
  async completeUserExam(params) {
    return (await roomExamService.completeUserExam(params)).data;
  }
  async getAllUserAnswers(params) {
    return (await roomExamService.getAllUserAnswers(params)).data;
  }
  async getUserAnswers(params) {
    return (await roomExamService.getUserAnswers(params)).data;
  }
}

export const Exam = new ExamApi();
